import _ from "lodash";
import { Permission, Role } from "../user/model/authorityGroup";

export const vsName = "userProfile";

export interface UserInfo {
  FirstName: string;
  LastName: string;
  DisplayName: string;
  PropertyIds: number[];
  UserAuthId: number | undefined;
  UserName: string;
  Roles: Role[];
  Permissions: Permission[];
  LockedDate: Date | undefined;
  Id: number | undefined;
}

export class UserProfile {
  FirstName: string = "";
  LastName: string = "";
  DisplayName: string = "";
  PropertyIds: number[] = [];
  UserAuthId: number | undefined;
  UserName: string = "";
  Roles: string[] = [];
  Permissions: string[] = [];
  LockedDate: Date | undefined;
  Id: number | undefined;

  constructor(serverProfile: {
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    PropertyIds?: number[];
    UserAuthId?: number;
    UserName?: string;
    Roles?: Role[];
    Permissions?: Permission[];
  }) {
    this.initialize(serverProfile);
  }

  initialize(serverProfile: {
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    PropertyIds?: number[];
    UserAuthId?: number;
    UserName?: string;
    Roles?: Role[];
    Permissions?: Permission[];
  }) {
    const vals = serverProfile || {};
    this.FirstName = vals.FirstName ?? "";
    this.LastName = vals.LastName ?? "";
    this.DisplayName = vals.DisplayName ?? "";
    this.PropertyIds = vals.PropertyIds ?? [];
    this.UserAuthId = this.Id = vals.UserAuthId;
    this.UserName = vals.UserName ?? "";
    this.Roles = vals.Roles?.map((r) => this._normalizeName(r.RoleName)) ?? [];
    this.Permissions =
      vals.Permissions?.map((p) => this._normalizeName(p.PermissionName)) ?? [];
  }

  isAdmin() {
    return this.Roles.indexOf(this._normalizeName("admin")) > -1;
    //return this.profile.Permissions.indexOf(this._normalizeName('admin')) > -1
  }

  isAuthenticated() {
    return !!this.UserAuthId;
  }

  hasPermission(permission: string): boolean {
    const name = this._normalizeName(permission);
    return this.isAdmin() || this.Permissions.indexOf(name) > -1;
  }

  hasRole(role: string): boolean {
    var name = this._normalizeName(role);
    return this.isAdmin() || this.Roles.indexOf(name) > -1;
  }

  _normalizeName(name: string) {
    return name.toLowerCase();
  }
}
